const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "http://localhost:89").replace(
  /\/$/,
  ""
);

const ENDPOINTS = {
  fibra: "/api/ecommerce/medio-mayorista/fibra/products",
  resina: "/api/ecommerce/medio-mayorista/resina/products",
  flakes: "/api/ecommerce/medio-mayorista/flakes/products",
};

const IMAGE_FALLBACKS = {
  fibra: "/ecommerce/Fibras.png",
  resina: "/ecommerce/Resinas.png",
  flakes: "/ecommerce/Flakes.png",
};

export const KIT_CAROUSEL_ITEM = {
  image: "/ecommerce/FibraResinaForrar.png",
  label: "KIT METRO FIBRA + KILO RESINA",
  link: "/productos/medio-mayorista/kit-fibra-resina",
  imageFit: "contain",
  imageBg: "#f5f6f8",
};

export const normalizeString = (value) => {
  if (value === undefined || value === null) return null;
  const trimmed = String(value).trim();
  return trimmed.length ? trimmed : null;
};

const parseJsonResponse = async (response, fallbackMessage) => {
  const contentType = response.headers.get("content-type") || "";
  const text = await response.text();
  if (!response.ok || !contentType.includes("application/json")) {
    throw new Error(fallbackMessage);
  }
  return JSON.parse(text);
};

export const fetchMedioMayoristaProducts = async (category, fallbackMessage) => {
  const endpoint = ENDPOINTS[category];
  if (!endpoint) return [];
  const response = await fetch(`${API_BASE_URL}${endpoint}`);
  const data = await parseJsonResponse(response, fallbackMessage);
  return Array.isArray(data) ? data : [];
};

export const toCarouselItem = (product, category) => {
  const label = normalizeString(product?.name) || "PRODUCTO";
  return {
    image: normalizeString(product?.image_url) || IMAGE_FALLBACKS[category] || "/ecommerce/Fibras.png",
    label: label.toUpperCase(),
    link: `/productos/medio-mayorista/${category}/${product?.id}`,
    imageFit: "contain",
    imageBg: "#f5f6f8",
  };
};
